// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"b5134ad1","186":"d2afb38d","215":"37453767","372":"9a3d8586","738":"a02360ca","787":"c1112931","841":"ec7d4cc4","851":"a52616a8","856":"51f7fe9b"}[chunkId] + ".chunk.js";
};